export default {
  staleContentError: 'The content you are editing has changed. Please copy your edits and exit the editor.',
  leaveCommentLabel: 'Leave a comment',
}
